import React from 'react';
import '@assets/sass/components/buttons/primary-button.scss';

const PrimaryButton = ({onClick, text}) => {
    return <button
        onClick={onClick}
        className='primary-button'>
        {text}
    </button>
};

export default PrimaryButton;